export const ProfileRouting = [
  {
    path: "/subcontractManagement/profile/list",
    name: "subcontractManagement-profile-list",
    meta: { title: "分包合同" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/subcontract-management/profile/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/subcontractManagement/profile/create",
    name: "subcontract-management-profile-create",
    meta: { title: "新增分包合同" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/subcontract-management/profile/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/subcontractManagement/profile/edit/:id",
    name: "subcontract-management-profile-edit",
    meta: { title: "编辑分包合同" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/subcontract-management/profile/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/subcontractManagement/profile/detail/:id",
    name: "subcontract-management-profile-detail",
    meta: { title: "分包合同详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/subcontract-management/profile/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/subcontractManagement/profile/flowPrint/:id",
    name: "subcontract-management-profile-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/subcontract-management/profile/flow-print/index.vue"
        ),
  },
];
